// extracted by mini-css-extract-plugin
export default {"whatsapp":"ButtonWhatsapp_whatsapp__XkI3D","icon_whatsapp":"ButtonWhatsapp_icon_whatsapp__vMSYk"};